import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { useLoadPastOrders } from '@hooks/use-load-past-orders';
import { useLoadPastCateringOrders } from '@hooks/use-load-past-catering-orders';
import { useRedirectIfUnauthenticated } from '@hooks/use-redirect-if-unauthenticated';
import { Box, Flex, Container } from '@components/grid';
import { LoadingIndicator } from '@components/icons/loading-indicator';
import { H4 } from '@components/typography/new';
import { OrderAtTableCarousel } from '@components/carousel/order-at-table-carousel';
import { PastOrder } from './past-order';

const PastOrdersContainer = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};

const MenuPastOrders = observer(({ type, onReorder, bannerSlot, ...rest }) => {
  const { PastOrdersStore, MemberStore } = useRootStore();
  const { profile } = MemberStore;
  const isLoading = PastOrdersStore.loading;
  useRedirectIfUnauthenticated();
  if (type === 'catering') {
    useLoadPastCateringOrders();
  } else {
    useLoadPastOrders();
  }

  if (isLoading) {
    return (
      <PastOrdersContainer>
        <LoadingIndicator />
      </PastOrdersContainer>
    );
  }

  // Use filteredOrders to hide orders with unavailable daypart items
  const { filteredOrders } = PastOrdersStore;

  if (filteredOrders.length === 0) {
    return (
      <PastOrdersContainer>
        <Flex
          justifyContent="space-between"
          gap="16px"
          mb={{ xs: '-12px', md: '-40px' }}
          flexDirection={{ xs: 'column', md: 'row' }}
        >
          <Flex>
            <H4 my="0">Welcome, {profile.givenName}</H4>
          </Flex>
          {bannerSlot}
        </Flex>
      </PastOrdersContainer>
    );
  }

  return (
    <PastOrdersContainer {...rest}>
      <Flex
        justifyContent="space-between"
        gap="16px"
        mb={{ xs: '24px', md: '32px' }}
        flexDirection={{ xs: 'column', md: 'row' }}
      >
        <Flex>
          <H4 my="0">Welcome, {profile.givenName}</H4>
        </Flex>
        {bannerSlot}
      </Flex>
      <Box>
        <Box overflow="hidden">
          <OrderAtTableCarousel gap="24px">
            {type === 'catering'
              ? PastOrdersStore.sortedCateringOrders.map(
                  (order, i) => i < 3 && <PastOrder catering key={order.id} order={order} onReorder={onReorder} />
                )
              : filteredOrders.map(
                  (order, i) => i < 3 && <PastOrder key={order.id} order={order} onReorder={onReorder} />
                )}
          </OrderAtTableCarousel>
        </Box>
      </Box>
    </PastOrdersContainer>
  );
});

PastOrdersContainer.propTypes = { children: PropTypes.node };
PastOrdersContainer.defaultProps = { children: null };

MenuPastOrders.propTypes = {
  type: PropTypes.string,
  onReorder: PropTypes.func,
  bannerSlot: PropTypes.node,
};

MenuPastOrders.defaultProps = {
  type: undefined,
  onReorder: undefined,
  bannerSlot: null,
};

export { MenuPastOrders };
